declare const __TCVS_APP_VERSION__: string;
declare const __TCVS_BUILD_REV__: string;
declare const __TCVS_BUILD_TIME__: string;

export interface BuildInfo {
  version: string;
  revision: string;
  builtAt: string;
}

export const buildInfo: BuildInfo = {
  version: __TCVS_APP_VERSION__,
  revision: __TCVS_BUILD_REV__,
  builtAt: __TCVS_BUILD_TIME__,
};

export function shortRevision(revision: string): string {
  return revision.length > 7 ? revision.slice(0, 7) : revision;
}
